import { isWalletConnectConfigured } from './walletConnectProjectId'

/** Claves `localStorage` de wagmi (`createStorage` con prefijo `wagmi.`). */
const WAGMI_STORAGE_PREFIX = 'wagmi.'

/** Patrones de claves de sesión WalletConnect / Reown / RainbowKit. */
const WALLET_SESSION_KEY = /^wagmi\.|^wc@|^RK_|^W3M|^reown|^@appkit|^walletconnect/i

function storageKeys(storage: Storage): string[] {
  const keys: string[] = []
  for (let i = 0; i < storage.length; i++) {
    const key = storage.key(i)
    if (key) keys.push(key)
  }
  return keys
}

/** Devuelve claves de sesión wallet en `localStorage` (solo navegador). */
export function listWalletPersistedStorageKeys(storage: Storage = window.localStorage): string[] {
  return storageKeys(storage).filter((key) => WALLET_SESSION_KEY.test(key))
}

/** Elimina estado persistido de wagmi, WalletConnect y RainbowKit. */
export function clearWalletPersistedSession(storage: Storage = window.localStorage): void {
  for (const key of listWalletPersistedStorageKeys(storage)) {
    storage.removeItem(key)
  }
}

/**
 * Si WalletConnect no está configurado pero quedó sesión WC persistida, limpia antes
 * de que wagmi rehidrate (evita UI “conectada” con conector muerto).
 */
export function pruneStaleWalletConnectSession(storage: Storage = window.localStorage): void {
  if (isWalletConnectConfigured()) return

  const hasWalletConnectKeys = listWalletPersistedStorageKeys(storage).some((key) => key.startsWith('wc@'))
  const wagmiStore = storage.getItem(`${WAGMI_STORAGE_PREFIX}store`)
  const wagmiMentionsWalletConnect =
    typeof wagmiStore === 'string' && wagmiStore.toLowerCase().includes('walletconnect')

  if (hasWalletConnectKeys || wagmiMentionsWalletConnect) {
    clearWalletPersistedSession(storage)
  }
}
